/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid.ts";

function getGetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidUrl(
  classStudentId: GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams["classStudentId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/grade-and-frequence/class-students/${classStudentId}` as const,
  };
  return res;
}

/**
 * @description Retorna os Módulos da Turma com as Turmas associadas e as Disciplinas (Aulas + exame) organizadas por Disciplina. **(Requer Authorization para autenticação)**
 * @summary Dados de média e frequência da Turma (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-students/:classStudentId}
 */
export async function getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid(
  classStudentId: GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams["classStudentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidUrl(
      classStudentId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
